import { Add, Remove } from '@mui/icons-material';
import { Box, Button, Paper, Grid, TextField } from '@mui/material';
import { useState, useEffect } from 'react';
import { IFrequentadores } from '../../../services/api/action-plan/Seminario';

interface FrequentersProps {
    value: IFrequentadores[] | undefined
    onChange: (data: IFrequentadores[]) => void,
    smDown: boolean,
}

export const Frequenters = ({value, onChange, smDown}: FrequentersProps) => {

    const [ dataSeps, setDataSteps ] = useState<IFrequentadores[]>([]);

    const handleAdd = () => {
        const newItem: IFrequentadores = {};
        setDataSteps(prevDataSteps => {
          const newDataSteps = [...prevDataSteps, newItem];
          onChange(newDataSteps);
          return newDataSteps;
        });
    };

    const handleRemove = () => {
        setDataSteps(prevDataSteps => {
          const newDataSteps = prevDataSteps.slice(0, -1);
          onChange(newDataSteps);
          return newDataSteps;
        });
    };

    const handleChange = (index: number, field: keyof IFrequentadores, value: string) => {
        setDataSteps(prevDataSteps => {
          const newDataSteps = prevDataSteps.map((item, i) => i === index ? { ...item, [field]: value } : item);
          onChange(newDataSteps);
          return newDataSteps;
        });
    };

    useEffect(() => {
        if (value) {
            setDataSteps(value);
        }
    }, []);

    return(
        <Box padding={1}>
            <Box display={'flex'} flexDirection={smDown ? 'column' : 'row'} justifyContent={'center'} gap={2} padding={1}>
                <Button
                    variant='outlined'
                    startIcon={<Add/>}
                    sx={{borderRadius: '25px'}}
                    onClick={handleAdd}
                >
                    Adicionar
                </Button>
                <Button
                    variant='outlined'
                    startIcon={<Remove/>}
                    sx={{borderRadius: '25px'}}
                    onClick={handleRemove}
                >
                    Remover
                </Button>
            </Box>
            {dataSeps.map((item, index) => (
                <Box padding={1} component={Paper} sx={{borderRadius: '25px'}} key={index} margin={2}>
                        <Grid container padding={2} spacing={2}>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label='Nome'
                                    value={item.nome}
                                    name='nome'
                                    fullWidth
                                    onChange={(e) => handleChange(index, 'nome', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label='Contato'
                                    value={item.contato}
                                    name='empresa'
                                    fullWidth
                                    onChange={(e) => handleChange(index, 'contato', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={smDown ? 12 : 6}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label='Responsabilidade'
                                    value={item.tipologia_unidade}
                                    name='tipologia_unidade' 
                                    fullWidth
                                    onChange={(e) => handleChange(index, 'tipologia_unidade', e.target.value)}
                                />
                            </Grid>
                        </Grid>
                </Box>
            ))}
        </Box>
    );
};